import {
  Box,
  Group,
  ScrollArea,
  Stack,
  Text,
  Title,
  Tooltip,
} from '@mantine/core'
import classes from './StageList.module.css'
import cn from 'classnames'

export interface StageListItem {
  name: string
  count: number
}

export interface StageListProps {
  stages: StageListItem[]
  activeStage: string | undefined
  onClick: (stage: string) => void
}

export const StageList = (props: StageListProps) => {
  const { stages, activeStage, onClick } = props

  return (
    <Group gap="xs" mt="md" mx="md" wrap="nowrap" grow>
      {stages.map((stage: StageListItem, i) => (
        <Stack
          key={`stageList-${i}`}
          className={cn(classes.StageList, {
            [classes.StageList__active]: activeStage === stage.name,
          })}
          gap={0}
          p="xs"
          onClick={() => onClick(stage.name)}
          style={{ flexShrink: 0 }}
        >
          <Title order={5}>{stage.count.toLocaleString()}</Title>
          <Text size="sm" style={{ whiteSpace: 'pre' }}>
            {stage.name}
          </Text>
        </Stack>
      ))}
    </Group>
  )
}
